import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import T, { Translate } from '../../i18n/i18n';
import * as Tag from './Sidebar.styles';
import { Button, ButtonRow, Icon } from '../../../styles/globalComponents';
import { tableData } from '../../../services/tables';
import { charactersActions, editTableActions } from '../../../redux/actions';
import Keyboard from '../../../services/keyboardShortcuts';
import ResourceImage from '../../ResourceImage/ResourceImage';
import { FormatDate, ConvertToTime } from '../../../services/dates';


export default ({tableId}) => {

    const dispatch = useDispatch();
    const isOwner = useSelector(state => state.authState.isOwner);
    const [sideBarStatus,setSideBarStatus] = useState('');
    const [data,setData] = useState({});
    const history = useHistory();

    useEffect(() => {
        (async () => {
            let data = await tableData(tableId);
            setData(data);

            if (data.charsheetTemplate) {
                dispatch(charactersActions.setSheetTemplate(data.charsheetTemplate));
            }
        })();
    }, [dispatch, tableId]);

    useEffect(() => {
        let escapeKey = () => {
            setSideBarStatus('');
            return false;
        };

        if (sideBarStatus === 'opened') {
            Keyboard.register({key:'ESCAPE'}, escapeKey);
        }

        return () => {
            Keyboard.unregister({key:'ESCAPE'}, escapeKey);
        };
    }, [sideBarStatus]);

    const handleBack = () => {
        history.goBack();
    };

    const handleEdit = () => {
        setSideBarStatus('');
        dispatch(editTableActions.openWindow((v)=>setData(v), data));
    };

    const OpenSidebar = () => {
        setSideBarStatus('opened');
    }

    const CloseSidebar = () => {
        setSideBarStatus('');
    }

    return <>
        <Tag.Sidebar className={'scrollbar ' + sideBarStatus}>
            {data ? <>
                <Tag.TopContent>
                    <Tag.Thumbnail>
                        {data.thumbnail ? 
                            <ResourceImage resourceId={data.thumbnail} /> 
                        : 
                            <Icon color="#999" icon="\F02E9" />
                        }
                    </Tag.Thumbnail>
                    <Tag.Title>{data.name}</Tag.Title>
                </Tag.TopContent>
                <Tag.ButtonGroupTop>
                    <Tag.TableDetail>
                        <Tag.Section><T value={'tables.nextgame'} /></Tag.Section>
                        <Tag.Label>
                            {FormatDate(data.next)}
                        </Tag.Label>

                        <Tag.Section><T value={'tables.time'} /></Tag.Section>
                        <Tag.Label>
                            {data.start && data.end ?
                                Translate("tables.time-value").replace("$1", ConvertToTime(data.start, Translate("lang"))).replace("$2", ConvertToTime(data.end, Translate("lang")))
                            : null}
                            {data.start && !data.end ?
                                Translate("tables.time-value-from").replace("$1", ConvertToTime(data.start, Translate("lang")))
                            : null}
                            {!data.start && data.end ?
                                Translate("tables.time-value-to").replace("$1", ConvertToTime(data.end, Translate("lang")))
                            : null}
                            {!data.start && !data.end ?
                                <Tag.NoValue><T value="tables.time-novalue"/></Tag.NoValue>
                            : null}
                        </Tag.Label>

                        <Tag.Section><T value="tables.selectedSheet" /></Tag.Section>
                        <Tag.Label>
                            {data.charsheetTemplate && data.charsheetTemplate.name && data.charsheetTemplate.name.length ? data.charsheetTemplate.name : <T value="tables.noSheet" /> }
                        </Tag.Label>

                        <Tag.Section><T value={'tables.public'} /></Tag.Section>
                        <Tag.Label>
                            <T value={data.public ? "yes" : "no"} />
                        </Tag.Label>

                        <Tag.Section><T value={'tables.positions'} /></Tag.Section>
                        <Tag.Label>
                            {Translate(data.positions ? "tables.positions-value" : "tables.positions-value-nomax").replace("$1", data.numPlayers).replace("$2", data.positions)}
                        </Tag.Label>

                        <Tag.Section><T value={'tables.content'} /></Tag.Section>
                        <Tag.TagGroup>
                            {data.content && data.content.length ? data.content.map(c => <Tag.Tag key={c.id} color="#56B431">{c[Translate("lang")]}</Tag.Tag>) : <Tag.NoValue><T value="tables.no-tags"/></Tag.NoValue>}
                        </Tag.TagGroup>

                        <Tag.Section><T value={'tables.tools'} /></Tag.Section>
                        <Tag.TagGroup>
                            {data.tools && data.tools.length ? data.tools.map(t => <Tag.Tag key={t.id} color="#FFB800">{t[Translate("lang")]}</Tag.Tag>) : <Tag.NoValue><T value="tables.no-tags"/></Tag.NoValue>}
                        </Tag.TagGroup>
                    </Tag.TableDetail>
                    {isOwner ? <ButtonRow>
                        <Button color="#fc3" onClick={() => {handleEdit()}}><T value="tables.edit" /></Button>
                    </ButtonRow> : null }
                </Tag.ButtonGroupTop>
                <Tag.EmptySpace />
                <Tag.ButtonGroupBottom>
                    <Button onClick={() => {handleBack()}}><T value="tables.back" /></Button>
                </Tag.ButtonGroupBottom>
            </> : null }
        </Tag.Sidebar>
        <Tag.SidebarBackground onClick={()=>{CloseSidebar()}} className={sideBarStatus} />
        <Tag.SidebarButton title={Translate('gridtools.openmenu')} onClick={()=>{OpenSidebar()}} />
    </>
};